module.exports = __webpack_public_path__ + "img/step09_a_basket_basic_connect_left_right_brackets.abf439cc.png";